import { render, staticRenderFns } from "./CodeWordGroup.vue?vue&type=template&id=8fbd9962"
import script from "./CodeWordGroup.vue?vue&type=script&lang=js"
export * from "./CodeWordGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports